import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal,
  Spacer,
  Text,
  chakra,
} from "@chakra-ui/react";
import { useContext } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "wouter";

import { LdoAuthContext } from "@nens/ldo/auth-v1";
import { LocaleContext } from "@nens/react/contexts";

export default function Header() {
  const { username, tenantId, tenantName, tenants, setTenant } = useContext(LdoAuthContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const { locale, setLocale } = useContext(LocaleContext);
  const setLocation = useLocation()[1];
  const intl = useIntl();

  return (
    <>
      <Flex w="100%" alignItems="center">
        <Box onClick={() => setLocation("/")} cursor="pointer">
          <chakra.img src="/assets/logo BIJ12.svg" m={4} />
        </Box>
        <Spacer />
        <Spacer />
        <Menu>
          <MenuButton
            as={Button}
            bgColor="white"
            color="bij12_1.700"
            border="1px"
            borderColor="bij12_1.700"
            mx="2"
            py="22px"
            _active={{ bg: "#CC614D20", color: "bij12_1.700" }}
            _hover={{ bg: "#CC614D20", color: "bij12_1.700" }}
            leftIcon={<AiOutlineUser />}
            rightIcon={<ChevronDownIcon />}
            textAlign="left"
          >
            <Text
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
              w="200px"
              p="0"
              m="0"
            >
              {username}
            </Text>
            {tenantName ? (
              <Text
                opacity=".75"
                fontSize="xs"
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
                w="200px"
                p="0"
                m="0"
              >
                ({tenantName})
              </Text>
            ) : null}
          </MenuButton>
          <Portal>
            <MenuList zIndex="100">
              <MenuItem onClick={onOpen}>
                <FormattedMessage id="menu.change_tenant" defaultMessage="Change organisation" />
              </MenuItem>
              <MenuDivider />
              <MenuOptionGroup
                title={intl.formatMessage({
                  id: "menu.change_language",
                  defaultMessage: "Change language",
                })}
                value={locale}
              >
                <MenuItemOption value="nl" onClick={() => setLocale("nl")}>
                  Nederlands
                </MenuItemOption>
                <MenuItemOption value="en" onClick={() => setLocale("en")}>
                  English
                </MenuItemOption>
              </MenuOptionGroup>
              <MenuDivider />
              <MenuItem
                onClick={() => {
                  window.location.href = "/auth/auth/logout";
                }}
              >
                <FormattedMessage id="menu.logout" defaultMessage="Log out" />
              </MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <Menu>
              <MenuOptionGroup
                title={intl.formatMessage({
                  id: "menu.change_tenant",
                  defaultMessage: "Change organisation",
                })}
                value={"" + tenantId}
              >
                {tenants.map((tenant) => (
                  <MenuItemOption
                    value={"" + tenant.id}
                    key={tenant.id}
                    onClick={() => {
                      setTenant(tenant);
                      onClose();
                      toast({
                        title: intl.formatMessage({
                          id: "menu.toast.switched_orgs.title",
                          defaultMessage: "Changed to another organisation",
                        }),
                        description: intl.formatMessage(
                          {
                            id: "menu.toast.switched_orgs.description",
                            defaultMessage: "Switched to organisation {newOrg}",
                          },
                          {
                            newOrg: tenant.name,
                          }
                        ),
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                      });
                    }}
                  >
                    {tenant.name}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </Menu>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
